import axios from 'axios'
import store from '../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization : `Bearer ${store.state.user.attributes.token}` }

function stackProgramSponsorJobUpdateStatus (pFormdata) {
    const URI = `${BASE_URL}/api/programSponsorJob/stack/stackUpdateStatus`
    return axios.post(URI, pFormdata, { headers })
}

export { stackProgramSponsorJobUpdateStatus }